// extracted by mini-css-extract-plugin
module.exports = {"button":"button__jQNF7","buttonPrimary":"button-primary__2fFUV"};